import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { createPortal } from 'react-dom';
import { FaMapMarkerAlt } from 'react-icons/fa';
import SocialLinks from '../SocialLinks';
import { JOBS_URL, ORDER_ONLINE_URL } from '../../constants';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setIsScrolled(window.scrollY > 0);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <button className="menu-button" onClick={toggleMenu}>
          <div className="menu-icon">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>
        {/*<Link className="header-logo-container" to="/">
          <img src="/images/BurgerBarn_logo_sign-215x100.png" alt="Burger Barn Logo" className="header-logo" />
        </Link>*/}
        <Link className="header-text-container" to="/">
          <h1>THE BURGER BARN</h1>
        </Link>
        <a
          href="https://www.google.com/maps/search/?api=1&query=The+Burger+Barn&query_place_id=ChIJnV4BAK0TVIcRNpN6pZ1whAE"
          target="_blank"
          rel="noopener noreferrer"
          className="location-icon"
        >
          <FaMapMarkerAlt size={38} />
        </a>
      </div>
      {createPortal(
        <div className={`menu-overlay ${menuOpen ? 'open' : ''}`}>
          <button className="close-button" onClick={toggleMenu}>
            ✕
          </button>
          <nav className="menu">
            <Link to="/" onClick={toggleMenu}>
              <img src="/images/BurgerBarn_logo-400x426.jpg" alt="Burger Barn Logo" className="menu-logo" />
            </Link>
            <ul>
              <li>
                <Link to="/" onClick={toggleMenu}>Home</Link>
              </li>
              <li>
                <Link to="/menu" onClick={toggleMenu}>Menu</Link>
              </li>
              <li>
                <a
                  href={ORDER_ONLINE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={toggleMenu}
                >
                  Order Online
                </a>
              </li>
              <li>
                <Link to="/contact" onClick={toggleMenu}>Contact</Link>
              </li>
              <li>
                <a 
                  href={JOBS_URL} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  onClick={toggleMenu}
                >
                  Jobs
                </a>
              </li>
            </ul>
            <SocialLinks containerClass="social-links" />
            <p className="menu-copyright">&copy; {new Date().getFullYear()} Burger Barn. All rights reserved.</p>
          </nav>
        </div>,
        document.body
      )}
    </header>
  );
};

export default Header;